export default "__VITE_PUBLIC_ASSET__aeafb81f__"